<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <div class="page_all">
    <div style="position:absolute; width:100%; height:100%;">
      <img src="@/assets/bgi.png" height="100%" width="100%" />
    </div>
    <div style="position: absolute;width: 100%; height: 29%;">
      <img src="@/assets/logo.png" style="position: absolute;left: 0;right: 0;margin: 0 auto;height: 70%;bottom: 0;">
    </div>
    <div style="text-align: center;position: absolute;top: 57%;left:0;right:0;margin: 0 auto;">
      <p style="margin-top:20px;margin-bottom:20px;color: #fff;letter-spacing:3px;font-size: 18px;">校外人员来校访问申请</p>
      <!-- <router-link :to="{'name':'Apply','params':{'departcode':123}}"> -->
        <a class="btnItem btn-lg" style="margin-top: 3%;" id="applyBtn" @click="toApplyPage">申请入校</a>
      <!-- </router-link> -->
      <a class="btnItem btn-lg" style="margin-top: 3%;" @click="showProgressDialog = true">查询进度</a>
    </div>
    <!-- 查询进度 dialog -->
    <Dialog v-model:show="showProgressDialog" title="查询进度" show-cancel-button @confirm="fnShowProgress">
      <Cell class="default_sites_cell form_line_cell">
        <Field required v-model="checkZjh" label="请输入身份证件号查询" placeholder="请填写证件号" />
      </Cell>
    </Dialog>
  </div>
</template>

<script setup>
import fnGetData from '@/utils/request';
import {
  Cell, Dialog, Field, showDialog, showToast, showFailToast, showLoadingToast, closeToast
} from 'vant';
import { ref } from 'vue';
import router from '@/router/index'
import {useRoute} from 'vue-router';
const route = useRoute();// 在 Vue 中使用 hash 路由时，查询参数通常是在 `route.query` 中获取的。
// 不过，有时候可能因为路由配置或者 URL 解析的问题导致无法正确获取。
// 可以尝试使用 `window.location.search` 手动解析 URL 中的查询参数。
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const default_department = ref(urlParams.get('deptcode'));
// const default_department = ref(route.query.deptcode); // 部门
// 申请入校
const toApplyPage = () => {
  const deptCode = default_department.value ? default_department.value : 0;
  // 使用路径跳转而非命名路由，确保URL参数正确传递
  router.push(`/xwlf/apply/${deptCode}`);
}
// 查询进度 dialog
const showProgressDialog = ref(false); //是否显示查询进度dialog
const checkZjh = ref(localStorage.getItem("zjh")); // 需查询的证件号
const fnShowProgress = () => { // 确认查询进度 显示 进度popup
  if (!checkZjh.value) {
    showFailToast('请输入证件号')
    return Promise.resolve();
  }
  
  // 直接跳转到进度页面，不在home页面调用getInfo接口
  router.push({
    name:'Progress',
    params:{
      zjh:checkZjh.value
    }
  })
  
  return Promise.resolve();
}


</script>

<style>
.btnItem {
  position: relative;
  display: block;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 0;
  box-sizing: border-box;
  font-size: 17px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  line-height: 1.41176471;
  /* border-radius: 4px; */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  overflow: hidden;
  border-width: 0;
  outline: 0;
  -webkit-appearance: none;
  border: 1px solid #F0F0F0;
  letter-spacing: 3px;
}

button {
  height: auto;
  padding: 3px 6px;
  font-size: 12px;
  font-weight: initial;
  border: 1px solid #3370ff;
  border-radius: 3px;
  background: none;
  color: #3370ff;
  margin-left: 5px;
}

button.block {
  display: block;
  margin: auto;
  padding: 3px 20px;
  width: 70%;
}
</style>